import { keyframes, styled } from "styled-components";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevron-right.svg";
import { ReactComponent as Download } from "../../assets/icons/file-download.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const MainContainer = styled.div`
  flex-direction: column;
  background: #f6f6f9;
  min-height: 100vh;
  transition: all 0.3s ease-in-out;
  height: 100%;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  background: #484888;
  position: fixed;
  z-index: 1000;
  width: 100%;
`;

export const Container = styled.div`
  height: 100%;

  min-height: calc(100dvh - 335px);
  display: flex;
  /* justify-content: center; */
  flex-direction: row;
  transition: all 0.3s ease-in-out;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "4rem 30rem 8rem 4rem"
          : "4rem 4rem 8rem 30rem"
        : !props.$ar
        ? "4rem 4rem 8rem 10rem"
        : "4rem 10rem 8rem 4rem"
      : "4rem 4rem"};

  margin-top: 140px;
  width: 100%;
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;

export const StyledContainer = styled.div`
  height: 100%;
  min-height: calc(100dvh - 262px);

  display: flex;
  /* justify-content: center; */
  flex-direction: row;
  transition: all 0.3s ease-in-out;
  position: relative;
  /* align-items: center; */
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "4rem 30rem 8rem 4rem"
          : "4rem 4rem 8rem 30rem"
        : !props.$ar
        ? "4rem 4rem 8rem 10rem"
        : "4rem 10rem 8rem 4rem"
      : "4rem 4rem"};

  margin-top: 140px;
  width: 100%;
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;

export const ContainerColumn = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  flex-wrap: wrap;
  transition: all 0.3s ease-in-out;
  max-width: 144rem;
`;
export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  cursor: pointer;
`;

export const Column = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  width: 32rem;
  height: 9rem;
  gap: 1rem;
  border-radius: 1rem;
  padding: 1rem 2rem;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 1px 1px 4px 0px rgba(72, 72, 136, 0.35);
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  background-color: white;
  width: 32rem;
  height: 74rem;
  border-radius: 1rem;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 1px 1px 4px 0px rgba(72, 72, 136, 0.35);

  overflow-y: auto;

  padding: 1rem 1rem 5rem 1rem;
  position: relative;

  &&::-webkit-scrollbar {
    width: 3px;
  }
`;

export const Label = styled.span`
  color: #484888;
  font-family: "Avenir-Medium";
  user-select: none;
  font-size: 1.6rem;
  letter-spacing: -0.178px;
`;

export const Number = styled.span`
  font-family: "FrankfurterEF-Medium";
  user-select: none;
  font-size: 3.5rem;
  letter-spacing: -0.178px;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
`;

export const OrderContainer = styled.div`
  border-radius: 1rem;
  background-color: white;
  box-shadow: 1px 1px 4px 0px rgba(72, 72, 136, 0.5);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-direction: row;
  width: 100%;
  z-index: 2;
`;
export const OrderTitle = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 2rem;
  letter-spacing: -0.178px;
  user-select: none;
`;

export const OrderLightText = styled.span`
  color: rgba(0, 0, 0, 0.4);
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  letter-spacing: -0.178px;
  user-select: none;
`;

export const CreateText = styled.span`
  color: #484888;

  font-family: "Avenir-Medium";
  font-size: 1.4rem;
  letter-spacing: -0.4px;
  user-select: none;
  position: absolute;
  white-space: nowrap;
  z-index: 100;

  transition: opacity 0.3s ease-in-out, left 0.6s ease-in-out;
  left: ${(props) => (props.$hovered ? "125%" : "0%")};
  top: 7.5px;
  opacity: ${(props) => (props.$hovered ? "1" : "0")};
`;
export const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8.5rem;
  z-index: 190;
  background: linear-gradient(0deg, red 35%, rgba(255, 255, 255, 0) 100%);
`;
export const AddContainer = styled.div`
  background-color: #484888;

  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 200;
  bottom: 1rem;
  cursor: pointer;
  left: 1rem;
  transition: all 0.45s ease-in-out;
  box-shadow: 1px 1px 4px 0px rgba(72, 72, 136, 0.25);
  &:hover {
    scale: 1.2;
  }
`;

export const Plus = styled.span`
  cursor: pointer;
  color: #fff;
  user-select: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;
  letter-spacing: -0.178px;
  z-index: 200;
`;

export const DropDownContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  flex-wrap: wrap;
`;
export const DropDownContent = styled.div`
  transition: all 0.3s ease-in-out;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 1px 1px 4px 0px rgba(72, 72, 136, 0.5);

  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 100%;
  gap: 2rem;
`;
export const ColumnDiv = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  width: 100%;
  @media (max-width: 500px) {
    width: 90%;
  }
`;
export const StyledColumnDiv = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;
`;
export const StyledRow2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;

  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;
  @media (max-width: 750px) {
    flex-wrap: wrap;
  }
`;

export const ImageContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
`;
export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.$noSpace ? "flex-start" : "space-between"};
  align-items: center;
  gap: ${(props) => (props.$noSpace ? "0.5rem" : "2rem")};
  flex-wrap: wrap;
`;
export const Input = styled.input`
  border-radius: 1.5rem;
  border: 1px solid #0008;
  background: #fff;
  padding: 22px 1rem;
  width: 41rem;
  font-size: 1.6rem;
  text-transform: ${(props) => (props.$noCapitalize ? "none" : "capitalize")};
  cursor: text;
  font-family: "Avenir-Medium";
  letter-spacing: -0.178px;

  &:focus {
    background-color: #fff;
    border: 1px solid #484888;
  }
  &::placeholder {
    color: #666;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
export const SubTitle = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 1.8rem;
  text-transform: ${(props) => (props.$noCapitalize ? "none" : "capitalize")};

  letter-spacing: -0.178px;
`;
export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropDownTitle = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 2.6rem;
  letter-spacing: -0.178px;
  user-select: none;
`;

export const DropDownLightText = styled.span`
  color: rgba(0, 0, 0, 0.4);
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  user-select: none;
  letter-spacing: -0.178px;
`;

export const Chevron = styled(ChevronSvg)`
  transition: all 0.3s ease-in-out;
  transform: ${(props) => (props.$open ? "rotate(90deg)" : "0deg")};
`;
export const ChevronLeft = styled(ChevronSvg)`
  transform: rotate(180deg);
  fill: black;
  path {
    stroke-width: 1px;
  }
`;

export const Button = styled.button`
  color: #fff;
  text-align: center;
  font-family: "FrankfurterEF-Medium";
  font-size: 2rem;
  border-radius: 1rem;
  background: ${(props) => (props.$red ? "#484888" : "#85a195")};

  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  outline: none;
  user-select: none;
  cursor: pointer;
  width: 30rem;
  height: 5rem;
  border: none;
  align-self: center;
`;

export const ButtonDisabled = styled.button`
  color: #fff;
  text-align: center;
  font-family: "FrankfurterEF-Medium";
  font-size: 2rem;
  border-radius: 1rem;
  background: ${(props) => (props.$red ? "#484888" : "#85a195")};
  margin-top: ${(props) => (props.$red ? "4rem" : "0rem")};

  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  outline: none;
  user-select: none;
  cursor: not-allowed;
  width: 30rem;
  height: 5rem;
  border: none;
  align-self: center;
  opacity: 0.65;
`;

export const SmallButton = styled.button`
  color: ${(props) => (props.$cancel ? "#000" : "#fff")};
  text-align: center;
  font-family: "FrankfurterEF-Medium";
  font-size: 2.2rem;
  border-radius: 1.5rem;
  background: ${(props) => (props.$cancel ? "#E4D9DC" : "#484888")};

  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  outline: none;
  user-select: none;
  cursor: pointer;
  width: 14rem;
  height: 3.5rem;
  border: 1px #8c8c8c;
  align-self: center;
`;
export const UploadContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: rgba(72, 72, 136, 0.05);
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding: 1rem 2rem;
  width: calc(100% + 4rem);
  margin-left: -2rem;
  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;
`;

export const UploadLabel = styled.span`
  font-family: "Avenir-Light";
  font-size: 1.6rem;
  letter-spacing: -0.178px;
`;
export const DownloadIcon = styled(Download)`
  cursor: pointer;
  path {
    fill: black;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: auto;
  width: 100%;
  padding: 1rem 2rem;
`;

export const Total = styled.span`
  font-family: "Avenir-Medium";
  font-size: 2.4rem;
  letter-spacing: 0.067px;
`;
export const Price = styled.span`
  text-align: right;
  font-family: "FrankfurterEF-Medium";
  font-size: 3rem;
  letter-spacing: 0.067px;
`;
export const Vat = styled.span`
  color: rgba(0, 0, 0, 0.5);
  font-family: "Avenir-Light";
  font-size: 1.4rem;
`;

export const NotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  padding: 2rem;

  border-radius: 3rem;
  border: 1px solid #b1b1b1;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const TextArea = styled.textarea`
  border: 1px solid rgba(0, 0, 0, 0.25);
  background: rgba(72, 72, 136, 0.01);
  min-height: 20rem;
  outline: none;
  padding: 1rem;
  font-family: "Avenir-Medium";
  font-size: 1.4rem;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 84rem;
`;

export const ItemsColumn = styled.div`
  width: 100%;
  max-height: calc(56.5rem * 3);
  gap: 2rem;

  padding: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }

  @media (max-width: 1250px) {
    align-items: center;
  }
`;

export const ItemPhoto = styled.img`
  width: 15rem;
  height: 15rem;
  object-fit: contain;
`;

export const ItemName = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 3rem;
  letter-spacing: 0.067px;
`;

export const ItemLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  letter-spacing: 0.067px;
`;

export const ItemPrice = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 2rem;
`;

export const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: ${(props) => (props.$small ? "fit-content" : "20rem")};
  max-width: 20rem;
  gap: 1rem;
`;
export const Color = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export const Size = styled(Color)`
  background-color: #484888;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SizeValue = styled.span`
  user-select: none;
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1rem;

  margin-bottom: -2px;
`;

export const StyledItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: ${(props) => (props.$small ? "fit-content" : "20rem")};
  max-width: 20rem;
  gap: 1rem;
  align-self: flex-start;
`;
export const Colors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  align-items: center;
`;
export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
  min-width: ${(props) => (props.$small ? "fit-content" : "100%")};
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ItemContainer = styled.div`
  display: flex;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);

  flex-direction: row;
  width: 100%;
  padding: 2rem;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;
  justify-content: space-between;
  @media (max-width: 700px) {
    justify-content: center;
  }
`;

export const ItemSpecifications = styled.span`
  font-family: "Avenir-Medium";
  user-select: none;
  font-size: 1.4rem;
  @media (max-width: 955px) {
    text-align: center;
  }
`;

export const ItemProduction = styled(ItemPrice)`
  font-size: 1.4rem;
`;
export const ItemQuantity = styled(ItemPrice)`
  color: #85a195;
`;

export const Img = styled.img`
  width: 8rem;
  height: 8rem;
  object-fit: contain;
`;
export const PdfContainer = styled.div`
  width: 8rem;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UploadLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 20rem;
  gap: 2rem;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const Fade = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;
`;

export const Notes = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;
export const SmallButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  margin-top: 1rem;
`;

export const FooterText = styled(ItemSpecifications)`
  color: #7f7f7f;
  margin-top: 1rem;
  margin-left: auto;
`;
export const FadeInOut = styled.div`
  transition: opacity 0.3s ease-in-out;
  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ScrollDownContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.2s ease-in-out;

  border-radius: 25%;
`;

export const ImgContainer = styled.div`
  width: 15rem;
  height: 15rem;
  position: relative;
  display: flex;
`;

export const LoaderContainerPhoto = styled.div`
  /* width: 20rem;
  height: 17rem; */
  position: absolute;
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(3px);
  background: rgba(255, 255, 255, 0.35);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;
